import { createContext as o } from "react";
const e = o({
  setShowDropdown: () => {
    console.warn("DropdownMenuContext::setShowDropdown called without a provider");
  }
});
export {
  e as default
};
